
        import '/home/builduser/work/5d4c7c61b0622e62/santa-editor/packages/sections/components/StageSideArea/StageSideArea.scss.css.virtualfile';
        module.exports = {"container":"_container_wyr3c_7","stageSideArea":"_stageSideArea_wyr3c_16","highlighted":"_highlighted_wyr3c_23","left":"_left_wyr3c_25"};